var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseCircle = function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60 60"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "close-circle_svg__a",
    d: "M0 0h60v60H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "close-circle_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#close-circle_svg__a"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29,
    stroke: "#FFF",
    strokeWidth: 2,
    mask: "url(#close-circle_svg__b)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#close-circle_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.572 16.5 1.929-1.928L45.428 43.5l-1.929 1.929z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.5 14.572 1.928 1.929L16.5 45.428l-1.929-1.929z"
  })))));
};
export default SvgCloseCircle;